// Contexto del carrito
import { createContext, useState } from 'react';

// Crear el contexto
export const CarritoContext = createContext();

const CarritoProvider = ({ children }) => {
  const [productosCarrito, setProductosCarrito] = useState([]);

  // Función para agregar un producto al carrito
  const agregarProductoAlCarrito = (nuevoProducto) => {
    setProductosCarrito((estadoPrevio) => {
      const existe = estadoPrevio.find((producto) => producto.codigo === nuevoProducto.codigo);
      if (existe) {
        return estadoPrevio.map((producto) =>
          producto.codigo === nuevoProducto.codigo
            ? { ...producto, cantidad: producto.cantidad + nuevoProducto.cantidad }
            : producto
        );
      } else {
        return [...estadoPrevio, { ...nuevoProducto, cantidad: nuevoProducto.cantidad }];
      }
    });
  };
  const comprarDirectamente = (productoUnico) => {
    setProductosCarrito([{ ...productoUnico, cantidad: productoUnico.cantidad }]);
  };

  // Función para eliminar un producto específico del carrito
  const eliminarProductoDelCarrito = (codigo) => {
    setProductosCarrito((estadoPrevio) =>
      estadoPrevio.filter((producto) => producto.codigo !== codigo)
    );
  };

  // Función para modificar la cantidad de un producto
  const modificarCantidadProducto = (codigo, cantidad) => {
    setProductosCarrito((estadoPrevio) =>
      estadoPrevio.map((producto) =>
        producto.codigo === codigo
          ? { ...producto, cantidad: Math.max(1, producto.cantidad + cantidad) }
          : producto
      )
    );
  };

  return (
    <CarritoContext.Provider
      value={{
        productosCarrito,
        agregarProductoAlCarrito,
        eliminarProductoDelCarrito,
        modificarCantidadProducto,
        comprarDirectamente
      }}
    >
      {children}
    </CarritoContext.Provider>
  );
};

export default CarritoProvider;
